import {Navigate, Routes, Route, useLocation} from "react-router-dom";
import Home from "../../pages/Home/Home";
import Movie from "../../pages/Movie/Movie";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Project from "../../pages/Project/Project";

function AppWrapper () {
    const route = useLocation();
    const path = route.pathname.replace(/\//g, "");
    const currentPath = path || 'home';

    return (
                <div className={`container ${currentPath}`}>
                    <Header/>
                        <Routes>
                            <Route path="/" element={<Home/>} />
                            <Route path="/cinematography" element={<Navigate to="/#cinematography" replace />} />
                            <Route path="/cinematography/movie/:movieName" element={<Movie/>} />
                            <Route path="/dance" element={<Navigate to="/#dance" replace />} />
                            <Route path="/dance/project/:projectName" element={<Project/>} />
                            <Route path="/exhibition" element={<Navigate to="/#exhibition" replace />} />
                            <Route path="/exhibition/project/:projectName" element={<Project/>} />
                            <Route path="/directing" element={<Navigate to="/#directing" replace />} />
                            <Route path="/directing/movie/:movieName" element={<Movie/>} />
                            <Route path="/private-projects/project/:projectName" element={<Project/>} />
                            <Route path="/bio" element={<Navigate to="/#bio" replace />} />
                            <Route path="/contact" element={<Navigate to="/#contact" replace />} />
                        </Routes>
                    <Footer/>
                </div>
    );
}

export default AppWrapper;

